import {
  GET_LIST_PARTITIONS,
  GET_PORTOUT_DETAILS,
  SET_OPTIN,
  SET_OPTIN_PORTOUT,
  GET_OPTIN_PORTOUT_LIST,
  REPLY_TO_PARTITIONS,
  GET_PORTOUT_HISTORY
} from "redux/constants";

const initialState = {
  partitionListData: [],
  portOutDetailsData: [],
  optinDetails: {},
  optinPortOutDetails: {},
  optinPortOutListData: [],
  portoutHistoryData: [],
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_LIST_PARTITIONS: {
      return {
        ...state,
        partitionListData: payload,
      };
    }

    case GET_PORTOUT_DETAILS: {
      return {
        ...state,
        portOutDetailsData: payload,
      };
    }

    case GET_OPTIN_PORTOUT_LIST: {
      return {
        ...state,
        optinPortOutListData: payload,
      };
    }

    case SET_OPTIN: {
      return {
        ...state,
        optinDetails: payload,
      };
    }

    case SET_OPTIN_PORTOUT: {
      return {
        ...state,
        optinPortOutDetails: payload,
      };
    }

    case REPLY_TO_PARTITIONS:
      return { ...state, partitionListData: [payload, ...state.partitionListData] }

    case GET_PORTOUT_HISTORY: {
      return {
        ...state,
        portoutHistoryData: payload,
      };
    }

    default:
      return state;
  }
};
export default reducer;
